import { Vimeo } from "@swizec/gatsby-theme-course-platform";
import * as React from 'react';
export default {
  Vimeo,
  React
};